import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import { connect, useSelector } from "react-redux";
import {
  getAuthToken,
  getUserInfo,
} from "../../../../../../services/authService";
import { getAllAthletesDataQuery } from "../../../../../common/CommonQuery";
import { Link } from "react-router-dom";
import { imageDownloadUrl, imageUploadUrl } from "../../../../../../config";
import { followRecruitCountListStart } from "../../../../../../redux/athlete/dashboard/colleges/followRecruitCount";
import { userCollegeCardCountStart } from "../../../../../../redux/athlete/dashboard/colleges/userCollegeCardCount";
import {
  getCollegesCountsQuery,
  followRecruitCount,
} from "../../colleges/myColleges/CollegeListQuery";
import downloadPng from "../assets/img/download.png";
import PhotoIcon from "../../editUserProfile/assets/img/photoIcon.svg";
import { athletesDetailsStart } from "../../../../../../redux/common/athletesDetails";
import VerificationModal from "../VerificationModal";
import VerifiedModal from "../../VerifiedModal";
import Cropper from "react-easy-crop";
import Modal from "react-modal";
import { Button } from "@mui/material";
import getCroppedImg from "../../../onboarding/profilePhoto/CropImage";
import { saveOnboardingQuery } from "../../../onboarding/OnboardingQuery";
import { saveProfilePhotoStart } from "../../../../../../redux/athlete/dashboard/homepage/saveAthleteProfile";
import BackdropLoader from "../../../../../common/Loader";
import messagePopup from "../../../../../../utils/messagePopup";
import { getPostStart } from "../../../../../../redux/athlete/dashboard/homepage/posts";
import { fetchGraphMethod } from "../../../../../../services/httpService";
import { getViewAth, getViewAthQuery } from "./query";
import toastr from "toastr";
import swal from "sweetalert";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
};

const AthleteInfo = (props) => {
  let history = useHistory();
  const [isModal, setIsModal] = useState(false);
  const [isVarifiedModal, setShouldShowVerifiedShieldModal] = useState(false);
  const [fields, setFields] = useState({
    user: getUserInfo() ? getUserInfo() : 0,
    profileImagename: "",
    profileImage: null,
  });
  const store = useSelector((store) => store);

  const [loading, setLoading] = useState(false);

  const [image, setImage] = React.useState(null);
  const [croppedArea, setCroppedArea] = React.useState(null);
  const [crop, setCrop] = React.useState({ x: 0, y: 0 });
  const [zoom, setZoom] = React.useState(1);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [viewAth, setViewAth] = React.useState(0);
  const [isProfileChange, setIsProfileChange] = React.useState(false);

  useEffect(() => {
    if (!props.athleteData.data) {
      refreshPage();
    }
    props.userCollegeCardCountStart({
      query: getCollegesCountsQuery(getUserInfo()?.id),
    });
    props.followRecruitCountListStart({
      query: followRecruitCount,
      variables: {
        where: {
          followingid: getUserInfo().id,
          followercoachid: { neq: null },
        },
      },
    });
  }, []);

  useEffect(() => {
    if (props.athleteData.data) {
      const fieldT = fields;
      const { onboardingData, athletesData } = props.athleteData.data;
      fields["athleteData"] = athletesData;
      fieldT["profileImagename"] = onboardingData
        ? onboardingData.profileimages
          ? onboardingData.profileimages
          : ""
        : "";
      fieldT["profileImage"] = onboardingData
        ? onboardingData.profileimages
          ? `${imageDownloadUrl}/${onboardingData.profileimages}`
          : ""
        : "";
      fieldT["onboardingData"] = onboardingData;
      setFields({ ...fieldT });
    }
  }, [props.athleteData.data]);

  useEffect(() => {
    const cloneT = fields;
    cloneT.user = getUserInfo();
    setFields({ ...cloneT });
  }, [store?.athlete?.editUserProfileData?.renderCount?.count]);

  useEffect(() => {
    getAthView(getUserInfo()?.id ?? 0);
  }, []);

  const getAthView = async (value) => {
    const _res = await fetchGraphMethod(
      getViewAthQuery,
      { obj: { profileviewto: +value } },
      true
    );
    if (_res?.status == 200) {
      const totalView = _res?.data?.data?.allUserprofileviews?.totalCount ?? 0;
      setViewAth(totalView);
    }
  };

  const CollegePage = (tab) => {
    // history.push("/colleges/list");
    if (tab) {
      history.push({
        pathname: "/colleges/list",
        state: { active: tab },
      });
    } else {
      history.push("/colleges/list");
    }
  };

  const onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
    setCroppedArea(croppedAreaPixels);
  };

  const onSelectFile = (event) => {
    const filedetails = event.target.files[0].type.split("/");
    let fileExtention =
      event.target.files[0].type.split("/")[filedetails.length - 1];

    let fileSize = event.target.files[0].size / (1024 * 1024);
    if (
      !(
        fileExtention.toLowerCase() == "jpg" ||
        fileExtention.toLowerCase() == "png" ||
        fileExtention.toLowerCase() == "jpeg" ||
        fileExtention.toLowerCase() == "gif"
      )
    ) {
      // messagePopup("", "Image format must be jpg, png, jpeg, gif. ", "error");
      toastr.error("Image format must be jpg, png, jpeg, gif.", "", {
        progressBar: true,
        timeOut: 2000,
        closeButton: true,
        positionClass: "toast-top-full-width",
        showEasing: "swing",
        fadeIn: 40000,
        preventDuplicates: true,
      });
      setIsOpen(false);
      setLoading(false);
    } else if (parseFloat(fileSize).toFixed(2) >= 10) {
      // messagePopup("", "Image size should be of maximum 10 MB.", "error");
      toastr.error("Image size should be of maximum 10 MB.", "", {
        progressBar: true,
        timeOut: 2000,
        closeButton: true,
        positionClass: "toast-top-full-width",
        showEasing: "swing",
        fadeIn: 40000,
        preventDuplicates: true,
      });
    } else if (event.target.files && event.target.files.length > 0) {
      const fieldsT = fields;
      const reader = new FileReader();
      if (event.target.files[0]) {
        fieldsT["fileName"] = event.target.files[0].name;
        fieldsT["fileType"] = event.target.files[0].type;
      }
      setFields(fieldsT);
      reader.readAsDataURL(event.target.files[0]);
      reader.addEventListener("load", () => {
        setImage(reader.result);
        setIsOpen(true);
        setIsProfileChange(true);
      });
    }
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const fieldsT = fields;
      const croppedImage = await getCroppedImg(image, croppedArea);
      fieldsT["profileImage"] = URL.createObjectURL(croppedImage);
      const fileArr = fieldsT["fileName"].split(".");
      fileArr[0] = new Date().getTime();
      var croppedFile = new File([croppedImage], fileArr.join("."), {
        lastModified: new Date(),
        type: fieldsT["fileType"],
      });
      setFields({
        ...fieldsT,
      });
      handleNext(croppedFile);
      setIsOpen(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedArea]);

  const handleNext = (selectedFile) => {
    setLoading(true);
    let formData = new FormData();
    formData.append("file", selectedFile);
    fetch(imageUploadUrl, {
      method: "POST",
      mode: "cors",
      body: formData,
      headers: {
        access_token: getAuthToken(),
      },
    })
      .then((resp) => resp.json())
      .then((response) => {
        setLoading(false);
        if (response) {
          const pathUrl = response.result?.files?.file[0]?.name
            ? response.result?.files?.file[0]?.name
            : "";
          props.saveProfilePhotoStart({
            query: saveOnboardingQuery,
            variables: {
              obj: {
                id: fields.onboardingData ? fields.onboardingData.id : 0,
                userid: getUserInfo().id,
                profileimages: pathUrl,
                // profileupdatedate: new Date() new key
                ...(isProfileChange && { profileupdatedate: new Date() }),
              },
            },
            refreshPage: refreshAfterSavePhoto,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        // messagePopup("", "Photo upload failed", "error");
        toastr.error("Photo upload failed", "", {
          progressBar: true,
          timeOut: 2000,
          closeButton: true,
          positionClass: "toast-top-full-width",
          showEasing: "swing",
          fadeIn: 40000,
          preventDuplicates: true,
        });
      });
  };

  const refreshAfterSavePhoto = () => {
    refreshPage();
    props.getPostStart({
      offset: 0,
      limit: 20,
      loginUserId: getUserInfo().id,
      firstDropDownValue: 1,
      secondDropDownValue: 1,
    });
    setIsProfileChange(false);
  };
  const getInitials = () => {
    let initial = "";
    if (props.athleteData.data && getUserInfo && getAuthToken()) {
      let data =
        props.athleteData &&
        props.athleteData.data &&
        props.athleteData.data.athletesData &&
        props.athleteData.data.athletesData;
      let firstname =
        data &&
        data.athletefirstname &&
        data.athletefirstname[0]?.toUpperCase();
      let lastname =
        data && data.athletelastname && data.athletelastname[0]?.toUpperCase();
      initial = firstname + lastname;
    }

    return initial;
  };
  const refreshPage = () => {
    props.athleteListStart({
      query: getAllAthletesDataQuery,
      variables: {
        obj: {
          id: getUserInfo() ? getUserInfo().id : 0,
        },
      },
    });
  };

  const showCroppedCancelImage = () => {
    setIsOpen(false);
  };

  return (
    <>
      <BackdropLoader open={props.saveProfilePhoto.loading || loading} />
      <div className="AthleteInfo ">
        <div className="profileBox">
          <div className="imgBoxBlock">
            <div className="imgBox">
              {fields.profileImage ? (
                <img
                  src={fields.profileImage}
                  alt="profile"
                  className="image"
                  style={{ width: "100px" }}
                />
              ) : (
                <div className="initialLetter">
                  <span>{getInitials()}</span>
                </div>
              )}
              <div className="container-cropper">
                <Modal
                  isOpen={modalIsOpen}
                  onRequestClose={() => setIsOpen(false)}
                  style={customStyles}
                  contentLabel="Example Modal"
                  ariaHideApp={false}
                >
                  <div>
                    <Cropper
                      image={image}
                      crop={crop}
                      zoom={zoom}
                      aspect={1}
                      onCropChange={setCrop}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                    <Button
                      onClick={showCroppedImage}
                      variant="contained"
                      color="primary"
                    >
                      Save
                    </Button>
                    <Button
                      className="imageCancel"
                      style={{ margin: "5px", background: "#C0321F" }}
                      onClick={showCroppedCancelImage}
                      variant="contained"
                      color="primary"
                    >
                      Cancel
                    </Button>
                  </div>
                </Modal>
              </div>
              <div className="browseEditProfile browse">
                {/* <img src={PhotoIcon} alt="Browse Photo" /> */}
                <label htmlFor="upload">+</label>
                <input
                  id="upload"
                  type="file"
                  accept="image/*"
                  name="file"
                  onChange={(e) => {
                    onSelectFile(e);
                    e.currentTarget.value = null;
                  }}
                />
              </div>
            </div>
            <div
              className="icon"
              onClick={() =>
                fields.user.verifiedUserStatus
                  ? setShouldShowVerifiedShieldModal(true)
                  : setIsModal(true)
              }
            >
              {fields.user.verifiedUserStatus ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26.418"
                  height="26.403"
                  viewBox="0 0 26.418 26.403"
                  className="verified"
                  style={{ display: "block" }}
                >
                  <path
                    className="a"
                    d="M-4229.021-6663.778a1.151,1.151,0,0,1-.986-.543,1.174,1.174,0,0,0-.993-.543,1.174,1.174,0,0,0-.993.543,1.151,1.151,0,0,1-.986.543,1.169,1.169,0,0,1-1.152-.9v-.005a1.179,1.179,0,0,0-1.149-.9,1.16,1.16,0,0,0-.728.256,1.169,1.169,0,0,1-.729.259,1.2,1.2,0,0,1-.883-.392,1.158,1.158,0,0,1-.3-.9l0-.013a1.161,1.161,0,0,0-.3-.9,1.184,1.184,0,0,0-.87-.387,1.181,1.181,0,0,0-.395.068h-.005a1.189,1.189,0,0,1-.4.07,1.175,1.175,0,0,1-.984-.544,1.155,1.155,0,0,1-.084-1.116l.01-.021a1.174,1.174,0,0,0-.088-1.121,1.175,1.175,0,0,0-.989-.538h-.033a1.163,1.163,0,0,1-1.08-.708,1.164,1.164,0,0,1,.219-1.274l.019-.019a1.171,1.171,0,0,0,.28-1.09,1.176,1.176,0,0,0-.769-.831l-.02,0a1.164,1.164,0,0,1-.8-1.02,1.164,1.164,0,0,1,.621-1.138l.02-.01a1.174,1.174,0,0,0,.621-.943,1.172,1.172,0,0,0-.456-1.031l-.02-.017a1.161,1.161,0,0,1-.425-1.223,1.164,1.164,0,0,1,.957-.875l.017,0a1.174,1.174,0,0,0,.894-.688,1.172,1.172,0,0,0-.1-1.125l-.013-.021a1.159,1.159,0,0,1-.058-1.2,1.173,1.173,0,0,1,1.03-.625,1.229,1.229,0,0,1,.215.019h.008a1.234,1.234,0,0,0,.21.019,1.166,1.166,0,0,0,.928-.459,1.169,1.169,0,0,0,.207-1.017l0-.017a1.148,1.148,0,0,1,.2-1.012,1.2,1.2,0,0,1,.938-.467,1.169,1.169,0,0,1,.572.151,1.16,1.16,0,0,0,.571.15,1.186,1.186,0,0,0,1.177-1.092v-.01a1.176,1.176,0,0,1,1.184-1.092,1.158,1.158,0,0,1,.866.39,1.159,1.159,0,0,0,.871.39,1.18,1.18,0,0,0,1.086-.715,1.162,1.162,0,0,1,1.084-.717,1.162,1.162,0,0,1,1.084.715,1.18,1.18,0,0,0,1.086.717,1.159,1.159,0,0,0,.871-.39,1.158,1.158,0,0,1,.866-.39,1.176,1.176,0,0,1,1.184,1.092v.01a1.186,1.186,0,0,0,1.177,1.092,1.16,1.16,0,0,0,.569-.148,1.164,1.164,0,0,1,.574-.153,1.2,1.2,0,0,1,.938.467,1.148,1.148,0,0,1,.2,1.012l-.005.017a1.169,1.169,0,0,0,.207,1.017,1.166,1.166,0,0,0,.928.459,1.234,1.234,0,0,0,.21-.019h.008a1.229,1.229,0,0,1,.215-.019,1.172,1.172,0,0,1,1.029.625,1.158,1.158,0,0,1-.057,1.2l-.013.021a1.172,1.172,0,0,0-.1,1.125,1.174,1.174,0,0,0,.894.688l.017,0a1.164,1.164,0,0,1,.958.875,1.161,1.161,0,0,1-.425,1.222l-.021.017a1.173,1.173,0,0,0-.456,1.032,1.174,1.174,0,0,0,.621.943l.021.01a1.164,1.164,0,0,1,.621,1.138,1.164,1.164,0,0,1-.8,1.02l-.02,0a1.179,1.179,0,0,0-.769.831,1.171,1.171,0,0,0,.283,1.09l.016.019a1.164,1.164,0,0,1,.218,1.273,1.163,1.163,0,0,1-1.08.708h-.033a1.175,1.175,0,0,0-.989.538,1.174,1.174,0,0,0-.088,1.121l.01.021a1.154,1.154,0,0,1-.083,1.116,1.175,1.175,0,0,1-.984.544,1.185,1.185,0,0,1-.4-.07h-.005a1.181,1.181,0,0,0-.395-.068,1.184,1.184,0,0,0-.87.387,1.161,1.161,0,0,0-.3.9v.013a1.157,1.157,0,0,1-.3.9,1.2,1.2,0,0,1-.883.392,1.159,1.159,0,0,1-.727-.259,1.164,1.164,0,0,0-.729-.256,1.181,1.181,0,0,0-1.15.9v0A1.168,1.168,0,0,1-4229.021-6663.778Zm-7.2-15.261a.709.709,0,0,0-.522.232l-1.041,1.122a.835.835,0,0,0,0,1.12l4.787,5.15a.712.712,0,0,0,.522.231.71.71,0,0,0,.52-.231l8.471-9.111a.84.84,0,0,0,0-1.122l-1.041-1.12a.711.711,0,0,0-.522-.232.705.705,0,0,0-.521.232l-6.908,7.43-3.226-3.469A.706.706,0,0,0-4236.221-6679.039Z"
                    transform="translate(4244.209 6690.181)"
                  />
                </svg>
              ) : null}
              {!fields.user.verifiedUserStatus ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25.828"
                  height="25.997"
                  viewBox="0 0 25.828 25.997"
                  className="unverified"
                  style={{ display: "block" }}
                >
                  <defs>
                    <style></style>
                  </defs>
                  <g transform="translate(-306 -179)">
                    <path
                      className="a"
                      d="M-5645.777-718.874a1.147,1.147,0,0,1,2.111,0l0,.009a1.147,1.147,0,0,0,1.91.317h0a1.146,1.146,0,0,1,2,.68l0,.034a1.146,1.146,0,0,0,1.7.916l.008,0a1.146,1.146,0,0,1,1.669,1.288l-.016.062a1.146,1.146,0,0,0,1.31,1.416l.033-.006a1.146,1.146,0,0,1,1.159,1.758l-.047.071a1.147,1.147,0,0,0,.776,1.761l.063.01a1.146,1.146,0,0,1,.521,2.038l-.071.055a1.146,1.146,0,0,0,.16,1.916l.074.04a1.146,1.146,0,0,1-.175,2.1l-.072.024a1.146,1.146,0,0,0-.474,1.864l.061.066a1.146,1.146,0,0,1-.852,1.924h-.049a1.147,1.147,0,0,0-1.058,1.61l.031.07a1.146,1.146,0,0,1-1.433,1.544l-.019-.007a1.147,1.147,0,0,0-1.527,1.182l0,.049a1.147,1.147,0,0,1-1.859,1l0,0a1.146,1.146,0,0,0-1.831.625l0,.02a1.146,1.146,0,0,1-2.082.344v0a1.146,1.146,0,0,0-1.937,0v0a1.146,1.146,0,0,1-2.082-.344l0-.02a1.146,1.146,0,0,0-1.831-.625l0,0a1.146,1.146,0,0,1-1.859-1l0-.049a1.146,1.146,0,0,0-1.527-1.182l-.019.007a1.146,1.146,0,0,1-1.434-1.544l.031-.07a1.146,1.146,0,0,0-1.057-1.61h-.049a1.146,1.146,0,0,1-.852-1.924l.061-.066a1.146,1.146,0,0,0-.474-1.864l-.072-.024a1.146,1.146,0,0,1-.175-2.1l.075-.04a1.146,1.146,0,0,0,.16-1.916l-.071-.055a1.146,1.146,0,0,1,.521-2.038l.062-.01a1.146,1.146,0,0,0,.777-1.761l-.047-.071a1.146,1.146,0,0,1,1.158-1.758l.034.006a1.146,1.146,0,0,0,1.31-1.416l-.016-.062a1.146,1.146,0,0,1,1.669-1.288l.008,0a1.146,1.146,0,0,0,1.7-.916l0-.034a1.146,1.146,0,0,1,2-.68h0a1.146,1.146,0,0,0,1.91-.317Z"
                      transform="translate(5963.635 898.573)"
                    />
                    <path
                      className="b"
                      d="M4.452-10.374,4.13-3.7H1.792L1.47-10.374ZM2.968.112A1.676,1.676,0,0,1,1.8-.287,1.309,1.309,0,0,1,1.358-1.3,1.33,1.33,0,0,1,1.8-2.324,1.658,1.658,0,0,1,2.968-2.73a1.638,1.638,0,0,1,1.155.406A1.33,1.33,0,0,1,4.564-1.3,1.315,1.315,0,0,1,4.123-.294,1.638,1.638,0,0,1,2.968.112Z"
                      transform="translate(315.642 197.374)"
                    />
                  </g>
                </svg>
              ) : null}
            </div>
          </div>

          <h5 className="playerName">
            {`${
              fields.athleteData ? fields.athleteData.athletefirstname : ""
            }  ${
              fields.athleteData ? fields.athleteData.athletelastname : ""
            }`}{" "}
          </h5>

          <ul>
            <li>
              <span className="label">Sport:</span>
              <span className="value">
                {" "}
                {fields.athleteData ? fields.athleteData.sportsName : ""}
              </span>
            </li>
            <li>
              <span className="label">Grad Year:</span>
              <span className="value">
                {fields.athleteData ? fields.athleteData.graduationYear : ""}
              </span>
            </li>
          </ul>
        </div>
        <ul className="flexBox">
          <li style={{ margin: "auto" }}>
            <span className="value">
              {/*{props?.userCollegeCardCount?.data?.collegeCount &&*/}
              {/*props?.userCollegeCardCount?.data?.userviewsCount*/}
              {/*  ? props?.userCollegeCardCount?.data?.collegeCount +*/}
              {/*    props?.userCollegeCardCount?.data?.userviewsCount*/}
              {/*  : 0}*/}
              {/* If number of views greater 999 then it will format the number with commas like 1,000  */}
              {viewAth > 999
                ? viewAth.toLocaleString("en-US", { maximumFractionDigits: 2 })
                : viewAth}
            </span>
            <span className="label">Views</span>
          </li>
          {/*<li>*/}
          {/*  <Link to={`/homepage/following`}>*/}
          {/*    <span className="value">*/}
          {/*      {fields.athleteData ? fields.athleteData.followings : 0}*/}
          {/*    </span>*/}
          {/*    <span className="label">following</span>*/}
          {/*  </Link>*/}
          {/*</li>*/}
          {/*<li>*/}
          {/*  <Link to={`/homepage/followers`}>*/}
          {/*    <span className="value">*/}
          {/*      {fields.athleteData ? fields.athleteData.followers : 0}*/}
          {/*    </span>*/}
          {/*    <span className="label">followers</span>*/}
          {/*  </Link>*/}
          {/*</li>*/}
        </ul>

        <Link className="profileLink" to="/basic">
          <span
            style={{
              background: "#1CB79E",
              padding: "8px",
              borderRadius: "10%",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="19"
              viewBox="0 0 24 19"
            >
              <path
                id="edit"
                d="M11.946,14.25l1.56-1.565-2.045-2.051L9.9,12.2v.756h1.292v1.3h.753Zm5.919-9.716a.278.278,0,0,0-.444.013L12.713,9.27a.305.305,0,1,0,.431.432l4.708-4.723a.279.279,0,0,0,.013-.445Zm1.076,8.016v2.564A3.888,3.888,0,0,1,15.067,19H3.875a3.725,3.725,0,0,1-2.738-1.141A3.752,3.752,0,0,1,0,15.113V3.887A3.747,3.747,0,0,1,1.137,1.141,3.73,3.73,0,0,1,3.875,0H15.067a3.689,3.689,0,0,1,1.574.337.411.411,0,0,1,.242.31.422.422,0,0,1-.121.392L16.1,1.7a.393.393,0,0,1-.431.108,2.377,2.377,0,0,0-.605-.081H3.875a2.069,2.069,0,0,0-1.52.634,2.082,2.082,0,0,0-.632,1.525V15.113a2.082,2.082,0,0,0,.632,1.525,2.069,2.069,0,0,0,1.52.634H15.067a2.162,2.162,0,0,0,2.152-2.159v-1.7a.4.4,0,0,1,.121-.3l.861-.864a.4.4,0,0,1,.471-.095.391.391,0,0,1,.269.392ZM17.65,2.591l3.875,3.887-9.04,9.068H8.61V11.659Zm5.973,1.781L22.385,5.613,18.511,1.727,19.748.486a1.3,1.3,0,0,1,1.83,0l2.045,2.051A1.251,1.251,0,0,1,24,3.455,1.251,1.251,0,0,1,23.623,4.372Z"
                fill="#fff"
              />
            </svg>
          </span>
          {/*<svg*/}
          {/*  xmlns="http://www.w3.org/2000/svg"*/}
          {/*  width="34"*/}
          {/*  height="34.001"*/}
          {/*  viewBox="0 0 34 34.001"*/}
          {/*  fill={'#1CB79E'}*/}
          {/*>*/}
          {/*  <defs>*/}
          {/*    <style></style>*/}
          {/*  </defs>*/}
          {/*  <path*/}
          {/*    className="a"*/}
          {/*    d="M-4214-6658h-30a2,2,0,0,1-2-2v-30a2,2,0,0,1,2-2h30a2,2,0,0,1,2,2v30A2,2,0,0,1-4214-6658Zm-19-13a7.008,7.008,0,0,0-7,7l0,1h22v-1a7.008,7.008,0,0,0-7-7Zm4-16a6.006,6.006,0,0,0-6,6,6.007,6.007,0,0,0,6,6,6.007,6.007,0,0,0,6-6A6.006,6.006,0,0,0-4229-6687Z"*/}
          {/*    transform="translate(4246 6692)"*/}
          {/*  />*/}
          {/*</svg>*/}
        </Link>
      </div>
      <div className="activityCollegeBox">
        {/*this code is commented for alpha 1.0 task on jira 206*/}
        {/*<div className="recuringActivity">*/}
        {/*  <h5 className="heading">Recruiting Activity</h5>*/}
        {/*  <ul className="flexBox">*/}
        {/*    <li>*/}
        {/*      <Link to={`/colleges/activity`}>*/}
        {/*        <span className="value">*/}
        {/*          {props?.userCollegeCardCount?.data?.collegeCount*/}
        {/*            ? props?.userCollegeCardCount?.data?.collegeCount*/}
        {/*            : 0}*/}
        {/*        </span>*/}
        {/*        <span className="label">Visits</span>*/}
        {/*      </Link>*/}
        {/*    </li>*/}
        {/*    <li>*/}
        {/*      <Link to={`/colleges/activity`}>*/}
        {/*        <span className="value">*/}
        {/*          {props?.followRecruitCount?.data?.totalCount*/}
        {/*            ? props?.followRecruitCount?.data?.totalCount*/}
        {/*            : 0}*/}
        {/*        </span>*/}
        {/*        <span className="label">Follows</span>*/}
        {/*      </Link>*/}
        {/*    </li>*/}
        {/*    <li>*/}
        {/*      <Link to={`/colleges/activity`}>*/}
        {/*        <span className="value">*/}
        {/*          {props?.userCollegeCardCount?.data?.groupCollegeCoachCount*/}
        {/*            ? props?.userCollegeCardCount?.data?.groupCollegeCoachCount*/}
        {/*            : 0}*/}
        {/*        </span>*/}
        {/*        <span className="label">Group</span>*/}
        {/*      </Link>*/}
        {/*    </li>*/}
        {/*    <li>*/}
        {/*      <Link to={`/colleges/activity`}>*/}
        {/*        <span className="value">*/}
        {/*          {props?.userCollegeCardCount?.data?.searchCount*/}
        {/*            ? props?.userCollegeCardCount?.data?.searchCount*/}
        {/*            : 0}*/}
        {/*        </span>*/}
        {/*        <span className="label">Searches</span>*/}
        {/*      </Link>*/}
        {/*    </li>*/}
        {/*  </ul>*/}
        {/*</div>*/}
        <div className="myCollege" style={{ cursor: "pointer" }}>
          <h5 className="heading">My Colleges</h5>
          <ul className="flexBox">
            <li onClick={() => CollegePage("")}>
              <span className="value">
                {props.userCollegeCardCount.data
                  ? props.userCollegeCardCount.data.total
                  : 0}
              </span>
              <span className="label">Favorites</span>
            </li>
            <li onClick={() => CollegePage("contact")}>
              <span className="value">
                {props.userCollegeCardCount.data
                  ? props.userCollegeCardCount.data.contact
                  : 0}
              </span>
              <span className="label">Contact</span>
            </li>
            <li onClick={() => CollegePage("collegeactive")}>
              <span className="value">
                {props.userCollegeCardCount.data
                  ? props.userCollegeCardCount.data.active
                  : 0}
              </span>
              <span className="label">Active</span>
            </li>
            <li
              onClick={
                () => {
                  swal({ title: "Coming soon", icon: "warning" });
                }
                // CollegePage("")
              }
            >
              <span className="value">0</span>
              <span className="label">Matches</span>
            </li>
          </ul>
        </div>
      </div>
      <Dialog
        open={isModal}
        onClose={(event, reason) => {
          if (reason == "backdropClick" || reason == "escapeKeyDown") {
            setIsModal(false);
          }
        }}
        className="matDialogCustom"
      >
        <VerificationModal
          athleteData={props.athleteData}
          setIsModal={setIsModal}
        ></VerificationModal>
      </Dialog>{" "}
      <Dialog
        open={isVarifiedModal}
        onClose={(event, reason) => {
          if (reason == "backdropClick" || reason == "escapeKeyDown") {
            setShouldShowVerifiedShieldModal(false);
          }
        }}
        className="matDialogCustom"
      >
        <VerifiedModal
          athleteData={props.athleteData}
          setShouldShowVerifiedShieldModal={setShouldShowVerifiedShieldModal}
        ></VerifiedModal>
      </Dialog>{" "}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    athleteData: state.common.athletesData,
    userCollegeCardCount: state.athlete.dashboard.colleges.userCollegeCardCount,
    saveProfilePhoto: state.athlete.dashboard.home.saveProfilePhoto,
    followRecruitCount: state.athlete.dashboard.colleges.followRecruitCountData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    athleteListStart: (data) => dispatch(athletesDetailsStart(data)),
    userCollegeCardCountStart: (data) =>
      dispatch(userCollegeCardCountStart(data)),
    followRecruitCountListStart: (data) =>
      dispatch(followRecruitCountListStart(data)),
    saveProfilePhotoStart: (data) => dispatch(saveProfilePhotoStart(data)),
    getPostStart: (data) => dispatch(getPostStart(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AthleteInfo);
